<app-card
  title="Order Complete!"
  data-qa-id="Order Complete Instructions"
  headerClasses="p-6 is-size-3 is-size-4-mobile has-text-weight-bold card-header-title has-text-white"
  [contentClasses]="'card-body-background p-6 ' + cardContentClass"
>
  @if (!storageService.baOrder?.isActive) {
    <p class="mb-4">
      Your order has been placed
      @if (inHomeBookingResult) {
        <span>!</span>
      } @else {
        {{
          !orderCompleteDetails || isFree || isPayLater
            ? '.'
            : ' and your card has been charged. The charge will appear on your statement as "ANALYTE HEALTH".'
        }}
      }
    </p>
  }

  @if (!inHomeBookingResult) {
    <div>
      <p class="mb-4">Our business hours are {{ businessHours }}.</p>
      <p class="mb-4">
        <strong>Next Steps:</strong> You will receive an email from us within 15 minutes with instructions on how to
        access your secure online portal where your lab order will be available. Please print and bring this lab order
        with you to the laboratory collection site. If you do not have a printer, you may present the lab order to the
        laboratory staff on your phone.
      </p>
    </div>
  } @else {
    <p class="mb-4">
      Your In-Home Collection has been scheduled for {{ inHomeBookingResult.date | date: 'MM/dd/yyyy' }} between
      {{ inHomeBookingResult.bookingSlot.period }}.
    </p>
    <p class="mb-4">
      Your specialist will arrive promptly at {{ inHomeBookingResult.address.street }},
      {{ inHomeBookingResult.address.city }}, {{ inHomeBookingResult.address.state }}
      {{ inHomeBookingResult.address.zipCode }} and will already have your paperwork ready.
    </p>
    <p class="mb-4">
      All we ask is before they arrive, please secure any pets you may have so they do not interfere with your
      appointment.
    </p>
    <p class="mb-4">{{ assistanceDetails }}</p>
  }

  <p data-qa-id="Cancellation Policy Section">
    <strong>Our Cancellation Policy:</strong> You may cancel your order any time before your
    {{ inHomeBookingResult ? 'In-Home Collection appointment' : 'specimen collection' }}.
    @if (orderCompleteDetails && !isFree && !isPayLater && !inHomeBookingResult) {
      <span>
        Refunds will be issued within 24-48 hours of cancellation
        <strong>minus a 20% cancellation fee</strong>.
      </span>
    }
    All cancellation requests after 21 days of purchase will be given credit for future testing.
  </p>
</app-card>
